import { RegExpUtility } from "../../../text/RegExpUtility";
import { leadingZeros } from "../../../text/leadingZeros";
import { AudioMath } from "../../AudioMath";
import { Composer } from "../Composer";

export enum ComposerTimeFormatType
{
  MINUTES_AND_SECONDS,
  BARS_AND_BEATS
}

export class ComposerTimeFormat
{
  static Apply( duration:number, type:ComposerTimeFormatType ):string
  {
    switch ( type )
    {
      case ComposerTimeFormatType.MINUTES_AND_SECONDS:
      {
        return ComposerTimeFormat.ConvertToTime( duration );
      }

      case ComposerTimeFormatType.BARS_AND_BEATS:
      {
        return ComposerTimeFormat.ConvertToBeats( duration );
      }
    }
  }

  static ConvertToTime( totalSeconds:number )
  { 
    let cs = Math.round( totalSeconds * 10 );
    let cents   = cs % 10;
    let seconds = Math.floor( totalSeconds ) % 60;
    let minutes = Math.floor( totalSeconds / 60 );

    let values = [ minutes, seconds, cents ];

    let strings = values.map( v => leadingZeros( v ) );

    return strings.join( ":" );
  }

  static ConvertToBeats( totalSeconds:number )
  { 
    let totalBeats = AudioMath.secondsToBeats( totalSeconds, Composer.$.bpm );
    let cs = Math.round( totalBeats * 10 );
    let cents   = cs % 10;
    let barLength = Composer.$.barLength;
    let beats = Math.floor( totalBeats ) % barLength;
    let bars = Math.floor( totalBeats / barLength );

    let values = [ bars + 1, beats + 1, cents ];

    let strings = values.map( v => leadingZeros( v ) );
    return strings.join( ":" );
  }
}